import "./index.scss";

class MapCustomControl {
  createResetPitchButton() {
    const button = window.document.createElement("button");
    button.className = "map-reset";
    button.innerHTML = "<span class='icon-refresh'></span>";
    button.addEventListener("click", () => {
      this.map.setBearing(0);
      this.map.setPitch(0);
    });
    this.container.appendChild(button);
    return button;
  }

  onAdd(map) {
    this.map = map;
    this.container = document.createElement("div");
    this.container.className = "mapboxgl-ctrl my-custom-control";
    this.createResetPitchButton();

    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}

export default MapCustomControl;
